// ABOUTME: Wires the reusable checkbox tree into role-edit selection state.

import React, {useCallback} from 'react'

import {CheckboxTree} from '../../../components/Tree/CheckboxTree'
import {CheckboxTreeNode} from '../../../common/types/tree'
import {
  getCheckedNodeIds,
  handleCheckboxTreeChange,
  handleCheckboxTreeToggle
} from '../../../common/utils/utils'

interface TreeSelectProps {
  treeData: CheckboxTreeNode[]
  onTreeDataChange: (newData: CheckboxTreeNode[]) => void
  onSelectedNodeIdsChange: (selectedNodeIds: (string | number)[]) => void
}

export const TreeSelect = ({
  treeData,
  onTreeDataChange,
  onSelectedNodeIdsChange
}: TreeSelectProps) => {
  const handleOnCheckboxChange = useCallback(
    (node: CheckboxTreeNode, checked: boolean) => {
      if (node.isDisabled) {
        return
      }

      const updatedTreeData = handleCheckboxTreeChange(treeData, node.id, checked)
      onTreeDataChange(updatedTreeData)
      onSelectedNodeIdsChange(getCheckedNodeIds(updatedTreeData))
    },
    [treeData, onTreeDataChange, onSelectedNodeIdsChange]
  )

  const handleOnToggle = useCallback(
    (node: CheckboxTreeNode) => {
      const updatedTreeData = handleCheckboxTreeToggle(treeData, node.id, !node.isOpen)
      onTreeDataChange(updatedTreeData)
    },
    [treeData, onTreeDataChange]
  )

  return (
    <CheckboxTree
      treeData={treeData}
      onToggleNode={handleOnToggle}
      onCheckNode={handleOnCheckboxChange}
    />
  )
}
